import React from "react";

const HeadTagEs = () => {
  return (
    <>
      <title>Cactus cloud - Acceso anticipado</title>
      <meta
        name="description"
        content="
        Optimiza la infraestructura de tu proyecto en minutos: optimiza la gestión de tu infraestructura de TI con nuestra plataforma, que ofrece una solución ágil, segura y escalable. Obtén un mayor control sobre tus recursos tecnológicos y maximiza tus ahorros. Contáctanos aquí para más información."
      />
      <meta
        name="keywords"
        content="microservices, domains, environments, apps, resources, frontends, monolithic, cloud, cactus cloud, aws, amazon Cactus,cloud, Cactus.cloud, cactus.cloud, cactus contact us, cactus contact"
      ></meta>
      <meta
        property="og:image"
        content="https://c4c7us.com/assets/images/landing-pages-images/logo192.png"
      ></meta>
      <meta
        name="google-site-verification"
        content="uxiEoSYNzAQXxMgOR2aHTuEuqWGPub2nKIPcnriafec"
      />
      <meta
        name="google-site-verification"
        content="LDFpkbRaAYXgpQ_Gi9WEEkmsBpytQZqcoRSWXfAFIoQ"
      />
    </>
  );
};

export default HeadTagEs;
